import { __awaiter, __generator } from 'tslib';
import { DbVersion } from './db-utils.js';

function openGamesDB() {
    return __awaiter(this, void 0, void 0, function () {
        function destroyDb() {
            return new Promise(function (res, rej) {
                var r = indexedDB.deleteDatabase(dbName);
                r.onsuccess = function () { return res(); };
                r.onerror = function () { return rej(r.error); };
            });
        }
        function createDb(db) {
            if (db.objectStoreNames.contains(gameStoreName)) {
                db.deleteObjectStore(gameStoreName);
            }
            if (db.objectStoreNames.contains(categoryStoreName)) {
                db.deleteObjectStore(categoryStoreName);
            }
            var gamesStore = db.createObjectStore(gameStoreName, {
                autoIncrement: true,
            });
            gamesStore.createIndex('slugIndex', 'slug', { unique: false });
            gamesStore.createIndex('gameIdIndex', 'gameId', {
                unique: false,
            });
            db.createObjectStore(categoryStoreName);
        }
        var dbName, gameStoreName, categoryStoreName, isFirstOpen, db, gamesTable, categoriesTable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dbName = 'games-db';
                    gameStoreName = 'games-array';
                    categoryStoreName = 'categories-array';
                    isFirstOpen = !sessionStorage.getItem('games-db-initialised');
                    if (!isFirstOpen) return [3 /*break*/, 2];
                    sessionStorage.setItem('games-db-initialised', 'true');
                    return [4 /*yield*/, destroyDb()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, new Promise(function (resolve, reject) {
                        var req = indexedDB.open(dbName, DbVersion);
                        req.onupgradeneeded = function (e) {
                            var db = e.target.result;
                            createDb(db);
                        };
                        req.onsuccess = function () { return resolve(req.result); };
                        req.onerror = function () { return reject(req.error); };
                    })];
                case 3:
                    db = _a.sent();
                    gamesTable = function (mode) {
                        if (mode === void 0) { mode = 'readonly'; }
                        return db.transaction(gameStoreName, mode).objectStore(gameStoreName);
                    };
                    categoriesTable = function (mode) {
                        if (mode === void 0) { mode = 'readonly'; }
                        return db.transaction(categoryStoreName, mode).objectStore(categoryStoreName);
                    };
                    return [2 /*return*/, {
                            put: function (games) {
                                return new Promise(function (resolve, reject) {
                                    var chunkSize = 100;
                                    var dataArray = Array.from(games.values());
                                    var index = 0;
                                    function processNextChunk() {
                                        var gamesT = db.transaction(gameStoreName, 'readwrite');
                                        var gameStore = gamesT.objectStore(gameStoreName);
                                        for (var i = 0; i < chunkSize && index < dataArray.length; i++, index++) {
                                            gameStore.put(dataArray[index]);
                                        }
                                        gamesT.oncomplete = function () {
                                            if (index < dataArray.length) {
                                                setTimeout(processNextChunk);
                                            }
                                            else {
                                                resolve();
                                            }
                                        };
                                        gamesT.onerror = function () { return reject(gamesT.error); };
                                    }
                                    processNextChunk();
                                });
                            },
                            get: function () {
                                return new Promise(function (res, rej) {
                                    var r = gamesTable().getAll();
                                    r.onsuccess = function () {
                                        res(new Map(r.result.map(function (game) { return [game.slug, game]; })));
                                    };
                                    r.onerror = function () { return rej(r.error); };
                                });
                            },
                            getBySlug: function (slug) {
                                return new Promise(function (res, rej) {
                                    var r = gamesTable().index('slugIndex').get(slug);
                                    r.onsuccess = function () { return res(r.result); };
                                    r.onerror = function () { return rej(r.error); };
                                });
                            },
                            getById: function (gameId) {
                                return new Promise(function (res, rej) {
                                    var r = gamesTable().index('gameIdIndex').get(gameId);
                                    r.onsuccess = function () { return res(r.result); };
                                    r.onerror = function () { return rej(r.error); };
                                });
                            },
                            putCategories: function (dataArray) {
                                return new Promise(function (resolve, reject) {
                                    var chunkSize = 100;
                                    var index = 0;
                                    function processNextChunk() {
                                        var categoriesT = db.transaction(categoryStoreName, 'readwrite');
                                        var categoriesStore = categoriesT.objectStore(categoryStoreName);
                                        for (var i = 0; i < chunkSize && index < dataArray.length; i++, index++) {
                                            var category = dataArray[index];
                                            categoriesStore.put(category, category.slug);
                                        }
                                        categoriesT.oncomplete = function () {
                                            if (index < dataArray.length) {
                                                setTimeout(processNextChunk);
                                            }
                                            else {
                                                resolve();
                                            }
                                        };
                                        categoriesT.onerror = function () { return reject(categoriesT.error); };
                                    }
                                    processNextChunk();
                                });
                            },
                            getCategoryBySlug: function (slug) {
                                return new Promise(function (res, rej) {
                                    var r = categoriesTable().get(slug);
                                    r.onsuccess = function () { return res(r.result); };
                                    r.onerror = function () { return rej(r.error); };
                                });
                            },
                            getCategories: function () {
                                return new Promise(function (res, rej) {
                                    var r = categoriesTable().getAll();
                                    r.onsuccess = function () { return res(r.result); };
                                    r.onerror = function () { return rej(r.error); };
                                });
                            },
                            close: function () {
                                db.close();
                            },
                        }];
            }
        });
    });
}

export { openGamesDB };
